module.exports = [
  ["-1200", "(GMT -12:00) Baker/Howland Island"],
  ["-1100", "(GMT -11:00) Samoa Time Zone, Niue"],
  ["-1000", "(GMT -10:00) Hawaii-Aleutian Standard Time, Cook Islands, Tahiti"],
  ["-0930", "(GMT -9:30) Marquesas Islands"],
  ["-0900", "(GMT -9:00) Alaska Standard Time, Gambier Islands"],
  ["-0800", "(GMT -8:00) Pacific Standard Time, Clipperton Island"],
  ["-0700", "(GMT -7:00) Mountain Standard Time"],
  ["-0600", "(GMT -6:00) Central Standard Time"],
  ["-0500", "(GMT -5:00) Eastern Standard Time, Western Caribbean Standard Time"],
  ["-0430", "(GMT -4:30) Venezuelan Standard Time"],
  ["-0400", "(GMT -4:00) Atlantic Standard Time, Eastern Caribbean Standard Time"],
  ["-0330", "(GMT -3:30) Newfoundland Standard Time"],
  ["-0300", "(GMT -3:00) Argentina, Brazil, French Guiana, Uruguay"],
  ["-0200", "(GMT -2:00) South Georgia/South Sandwich Islands"],
  ["-0100", "(GMT -1:00) Azores, Cape Verde Islands"],
  ["+0000", "(GMT) Greenwich Mean Time, Western European Time"],
  ["+0100", "(GMT +1:00) Central European Time, West Africa Time"],
  ["+0200", "(GMT +2:00) Central Africa Time, Eastern European Time, Kaliningrad Time"],
  ["+0300", "(GMT +3:00) Moscow Time, East Africa Time"],
  ["+0330", "(GMT +3:30) Iran Standard Time"],
  ["+0400", "(GMT +4:00) Azerbaijan Standard Time, Samara Time"],
  ["+0430", "(GMT +4:30) Afghanistan"],
  ["+0500", "(GMT +5:00) Pakistan Standard Time, Yekaterinburg Time"],
  ["+0530", "(GMT +5:30) Indian Standard Time, Sri Lanka Time"],
  ["+0545", "(GMT +5:45) Nepal Time"],
  ["+0600", "(GMT +6:00) Bangladesh Standard Time, Bhutan Time, Omsk Time"],
  ["+0630", "(GMT +6:30) Cocos Islands, Myanmar"],
  ["+0700", "(GMT +7:00) Krasnoyarsk Time, Cambodia, Laos, Thailand, Vietnam"],
  ["+0800", "(GMT +8:00) Australian Western Standard Time, Beijing Time, Irkutsk Time"],
  ["+0845", "(GMT +8:45) Australian Central Western Standard Time"],
  ["+0900", "(GMT +9:00) Japan Standard Time, Korea Standard Time, Yakutsk Time"],
  ["+0930", "(GMT +9:30) Australian Central Standard Time"],
  ["+1000", "(GMT +10:00) Australian Eastern Standard Time, Vladivostok Time"],
  ["+1030", "(GMT +10:30) Lord Howe Island"],
  ["+1100", "(GMT +11:00) Magadan Time, Solomon Islands, Vanuatu"],
  ["+1130", "(GMT +11:30) Norfolk Island"],
  ["+1200", "(GMT +12:00) Fiji, Gilbert Islands, Kamchatka Time, New Zealand Standard Time"],
  ["+1245", "(GMT +12:45) Chatham Islands Standard Time"],
  ["+1300", "(GMT +13:00) Phoenix Islands Time, Tonga"],
  ["+1400", "(GMT +14:00) Line Islands"]
];


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/utils/timezones.js
 **/